import Vue from 'vue/dist/vue.common.js';
export const EventBus = new Vue();
export default EventBus;